// Bus de eventos para toasts.
// Permite que cualquier módulo dispare un toast sin depender del árbol
// de componentes ni del estado de Preact.

const target = new EventTarget()

/**
 * @typedef {Object} ToastDetail
 * @property {string} message
 * @property {'info'|'success'|'warning'|'error'} [kind='info']
 * @property {number} [duration=3000] Milisegundos antes de auto-cerrar.
 */

/** @param {ToastDetail} detail */
export function showToast(detail) {
  target.dispatchEvent(new CustomEvent('toast', { detail }))
}

/**
 * Suscribe un callback al bus de toasts. Devuelve la función de
 * cancelación de suscripción.
 *
 * @param {(detail: ToastDetail) => void} callback
 */
export function onToast(callback) {
  const handler = (event) => callback(event.detail)
  target.addEventListener('toast', handler)
  return () => target.removeEventListener('toast', handler)
}
